import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import PersonOutlineRoundedIcon from '@mui/icons-material/PersonOutlineRounded'

import {
  UI_COLOR_BORDER_LIGHT,
  UI_COLOR_WHITE
} from '../../../constants/uiColors'

export const MY_PROFILE_TABS = [
  { id: 'informacion', value: 'informacion', label: 'Mi perfil', path: '/perfil', icon: PersonOutlineRoundedIcon },
  { id: 'seguridad', value: 'seguridad', label: 'Seguridad', path: '/perfil/seguridad', icon: LockOutlinedIcon }
]

export const MY_PROFILE_PAGE_TITLE = 'Mi perfil'
export const MY_PROFILE_SECTION_TITLE = 'Perfil'
export const MY_PROFILE_LOADING_TEXT = 'Cargando...'

export const myProfilePanelLoaderSx = {
  minHeight: 320,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: `1px solid ${UI_COLOR_BORDER_LIGHT}`,
  borderRadius: '18px',
  bgcolor: UI_COLOR_WHITE,
  px: 3,
  py: 5
}

export const myProfileLayoutSx = {
  display: 'grid',
  gridTemplateColumns: { xs: '1fr', md: '220px minmax(0, 1fr)' },
  gap: { xs: 2, md: 3 },
  alignItems: 'start'
}
